/**
 * @description: 标记重做 - 公共工具（时间范围转请求参数）
 */
import moment from 'moment';

export function momentArrDataToTimes(datas, key, unitOfTime = 'day') {
    if (datas && Array.isArray(datas)) {
        const times = {};
        const [start, end] = datas;
        times[`${key}_start`] = moment(start)
            .startOf(unitOfTime)
            .format('YYYY-MM-DD HH:mm:ss');
        times[`${key}_end`] = moment(end)
            .endOf(unitOfTime)
            .format('YYYY-MM-DD HH:mm:ss');
        return times;
    }
    return undefined;
}
